import * as React from "react";
import {translate} from "react-i18next";
import i18n from "i18next";
import {Header} from "../../components/Header";
import TextBody from "../../components/TextBody";
import BottomBar from "../../components/BottomBar";
import TopNav from "../../components/TopNav";
import {Container,Row,Col} from "reactstrap";
import StatusOverview from "../../components/StatusBar";
import vodafoneLogo from "../../media/icons/vf-logo.png";
import {SpacerRow} from "../../components/SpacerRow";
import {BrowserView,MobileView,isMobile} from "react-device-detect";
import InfoBlocks from "../../components/InfoBlocks";
import SingleButton from "../../components/SingleButton";
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import moment from "moment";

class StageTam6003Entry extends React.Component {

    constructor(props){
        super(props);
        // console.log( "FNX: StageTam6003Entry props");
        // console.log(props);
        this.state = { selectedOption: '' }
    }

    handleOnChange = (e) =>  {
        console.log('selected option', e.target.value);
        this.setState({ selectedOption: e.target.value});
    }

    /**
     * render
     * @returns {*}
     */
    render() {

        let WelcomeText;
        if(this.props.validationDone){
            WelcomeText = <Header
            textResource={"tam6003_entry_title"}
    />
    }else{
    WelcomeText = <Header
    textResource={"tam6003_entry_title"}
    name={`${this.props.apiData.firstName} ${this.props.apiData.lastName} `}
/>
}

const headerAndWelcomeText = <div>
	{WelcomeText}
	<div style={{marginTop:"20px"}}>
		<TextBody
			textResource={"tam6003_entry_body_1"}
		/>
    </div>
</div>;

const statusBar = <StatusOverview
showDescription={true}
    />;

/**
 * Top Navigation / "Footer" Link
 */
const footerLnk = <TopNav
buttonTextResource={"footer_link"}
buttonOnClick={this.props.openTopNav}
/>;

return <Container>

    <MobileView>
        <Row className={"header"}>
                        <Col xs={2} style={{marginLeft:"-15px"}}>
                            <img src={vodafoneLogo} className={"img-fluid"}  alt={"Vodafone Logo"}/>
                        </Col>
                    </Row>
		<Row style={{paddingTop:"5vh"}}>
            <Col xs={{ size: 12 }}>
				{headerAndWelcomeText}
            </Col>
		</Row>
		<Row style={{paddingTop:"20px"}}>
            <Col xs={{ size: 12 }}>
                <p className={"your_address"}>
                    {this.props.ds360APIResult.customer.firstName} {this.props.ds360APIResult.customer.lastName}<br />
                    {this.props.ds360APIResult.KAS_LOK_STRASSE} {this.props.ds360APIResult.KAS_LOK_HAUSNR}<br />
                    {this.props.ds360APIResult.KAS_LOK_PLZ} {this.props.ds360APIResult.KAS_LOK_ORT}
                </p>
                <TextBody
                    textResource={"tam6003_address_correct"}
                />
            </Col>
        </Row>

        <Row className={'fixed-to-bottom'} style={{paddingBottom:"50px"}}>
            <Col xs={{ size: 12 }} className={"twoButtons"}>
                <BottomBar
                    // mainButtonOnClick={this.props.nextStage}
                    mainButtonOnClick={() => {
                        // zum Retourenportal
                        // const proposalDate = moment(this.props.ds360APIResult.proposalDate);
                        // const isoSelectedDate = moment(this.state.selectedDate);
                        this.props.commonSubmitCallback("address_check_ok")
                    }}
                    mainButtonTextResource={"tam6003_entry_button_address_yes"}
                />
                <BottomBar
                    // mainButtonOnClick={this.props.nextStage}
                    mainButtonOnClick={() => {
                        // zum Retourenportal
                        // const proposalDate = moment(this.props.ds360APIResult.proposalDate);
                        // const isoSelectedDate = moment(this.state.selectedDate);
                        this.props.commonSubmitCallback("address_check_not_ok")
                    }}
                    showBackButtonValidation={true}
                    backButtonValidationOnClick={true}
                    backValidationButtonTextResource={"tam6003_entry_button_address_no"}
                />
            </Col>
        </Row>

    </MobileView>

    <BrowserView>
        <Row className={"header desktop"}>
            <Col xs={12}>
                <div className={"container"}>
                    <Row>
                        <Col xs={2} style={{marginLeft:"-15px"}}>
                            <img src={vodafoneLogo} className={"img-fluid"}  alt={"Vodafone Logo"}/>
                        </Col>
                    </Row>
                </div>
            </Col>
        </Row>
        <Row style={{paddingTop:"20vh"}}>
            <Col xs={{ size: 10, offset: 1 }}>
				{headerAndWelcomeText}
            </Col>
		</Row>
		<Row style={{paddingTop:"20px"}}>
            <Col xs={{ size: 10, offset: 1 }}>
                <p className={"your_address"}>
                    {this.props.ds360APIResult.customer.firstName} {this.props.ds360APIResult.customer.lastName}<br />
                    {this.props.ds360APIResult.KAS_LOK_STRASSE} {this.props.ds360APIResult.KAS_LOK_HAUSNR}<br />
                    {this.props.ds360APIResult.KAS_LOK_PLZ} {this.props.ds360APIResult.KAS_LOK_ORT}
                </p>
                <TextBody
                    textResource={"tam6003_address_correct"}
                />
            </Col>
        </Row>
        <Row style={{paddingTop:"20px"}}>
            <Col xl={{ size: 2, offset: 1 }} lg={{ size: 3, offset: 1 }} md={{ size: 4, offset: 1 }} sm={{ size: 6, offset: 1 }} xs={{ size: 12, offset: 0 }} className={"twoButtons"}>
                <BottomBar
                    // mainButtonOnClick={this.props.nextStage}
                    mainButtonOnClick={() => {
                        // zum Retourenportal
                        // const proposalDate = moment(this.props.ds360APIResult.proposalDate);
                        // const isoSelectedDate = moment(this.state.selectedDate);
                        this.props.commonSubmitCallback("address_yes")
                    }}
                    mainButtonTextResource={"tam6003_entry_button_address_yes"}
                />
            </Col>
            <Col xl={{ size: 2, offset: 0 }} lg={{ size: 3, offset: 0 }} md={{ size: 4, offset: 0 }} sm={{ size: 5, offset: 0 }} xs={{ size: 12, offset: 0 }} className={"twoButtons"}>
                <BottomBar
                    // mainButtonOnClick={this.props.nextStage}
                    mainButtonOnClick={() => {
                        // zum Retourenportal
                        // const proposalDate = moment(this.props.ds360APIResult.proposalDate);
                        // const isoSelectedDate = moment(this.state.selectedDate);
                        this.props.commonSubmitCallback("address_check_not_ok")
                    }}
                    showBackButtonValidation={true}
                    backButtonValidationOnClick={true}
                    backValidationButtonTextResource={"tam6003_entry_button_address_no"}
                />
            </Col>
        </Row>
    </BrowserView>
    </Container>
}
}

export default translate("translations")(StageTam6003Entry);